export default function PHP_error_reporting() {
  return (
    <div>
      <h1>PHP_error_reporting</h1>
    </div>
  );
}
